import type { AccountSettingKey } from "app/pages/sales-intelligence/services/api/account-settings/types";
import type { QueryKeyFactory } from "app/pages/sales-intelligence/types/queries";

const SI_QUERY_KEY = "si";

const ACCOUNT_SETTINGS_QUERY_KEY = "account-settings";
const ACCOUNT_ADMINS_QUERY_KEY = "account-admins";

const REQUEST_ACCESS_QUERY_KEY = "request-access";

const SITE_TAGS_QUERY_KEY = "site-tags";

const USER_ACTIVITY_QUERY_KEY = "user-activity";
const LAST_ACTIVITY_QUERY_KEY = "last-activity";

export const siQueryKeyFactory = {
    accountAdmins() {
        return [SI_QUERY_KEY, ACCOUNT_ADMINS_QUERY_KEY] as const;
    },

    accountAdminsRequestAccess() {
        return [SI_QUERY_KEY, ACCOUNT_ADMINS_QUERY_KEY, REQUEST_ACCESS_QUERY_KEY] as const;
    },

    siteTagsAutocomplete(term: string, size: number) {
        return [SI_QUERY_KEY, SITE_TAGS_QUERY_KEY, term, size] as const;
    },

    lastActivity() {
        return [SI_QUERY_KEY, USER_ACTIVITY_QUERY_KEY, LAST_ACTIVITY_QUERY_KEY] as const;
    },

    accountSetting(key: AccountSettingKey) {
        return [SI_QUERY_KEY, ACCOUNT_SETTINGS_QUERY_KEY, key] as const;
    },
} as const satisfies QueryKeyFactory;
